import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { PatientPersonalInfo,patientRefData,PatientfirstInakeData, auth } from 'src/app/models/verifypatient/verifypatient';
import { ExitingpatientService } from 'src/app/services/exitingpatient.service';
import { DatePipe } from '@angular/common';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-madison-injured',
  templateUrl: './madison-injured.component.html',
  styleUrls: ['./madison-injured.component.css']
})
export class MadisonInjuredComponent implements OnInit {

  IsproviderName : boolean = false;
  IsfacName: boolean = false ;
  IsphyName : boolean = false ;
  Isscript : boolean = false ;
  patientPersonalInfo: PatientPersonalInfo;
  patientintakedata : patientRefData = new patientRefData ();
  patientFirstInakeData : PatientfirstInakeData = new PatientfirstInakeData ();
  tempdata: any ;
  questionnaire_one : any = '';
  questionnaire_two : any;
  curDate = new Date();
  maxDate: any;
  constructor(private router: Router,private _login: ExitingpatientService,private datepipe: DatePipe,private spinner: NgxSpinnerService,private _phrutilService: PhrutillsService,private phrUtils: PhrutillsService) { 
    let info = localStorage.getItem('PersonalInfo');
    this.patientPersonalInfo = this.phrUtils.decrypt(info) as PatientPersonalInfo;
     this.tempdata = this.router.getCurrentNavigation()?.extras.state;
     this.patientFirstInakeData.Ref_person = this.tempdata.unReadFaxCount.Ref_person;
     this.patientFirstInakeData.visit_reason= this.tempdata.unReadFaxCount.visit_reason;
     this.patientFirstInakeData.Long_going = this.tempdata.unReadFaxCount.Long_going;

     //adding first intake value 
     this.patientintakedata.refPerson = this.patientFirstInakeData.Ref_person
     this.patientintakedata.visitReason = this.patientFirstInakeData.visit_reason
     this.patientintakedata.duration = this.patientFirstInakeData.Long_going
     
  }

  ngOnInit(): void {
  }

  focusOutFunction( data: any, type : any ){

     let date = data.value;
        if((new Date(this.maxDate)) < (new Date(date)))
        {
          return;
        }

   if(type=='physical'){
     this.patientintakedata.lastPhysicalDate = this.datepipe.transform(date, 'MM/dd/yyyy');
    }
    else if (type=='blood'){
      this.patientintakedata.lastBloodWorkDate = this.datepipe.transform(date, 'MM/dd/yyyy');
    }
    else if (type == 'rxdate'){
      this.patientintakedata.rxDate = this.datepipe.transform(date, 'MM/dd/yyyy');
    }
    
   }

  CheckType(data:any,type :any){
  
 let values = data.value;
    if (type == 'provider'){
       this.patientintakedata.lastProvider = values ;
          if(values == 'Yes')
           this.IsproviderName = true;
          else
          this.IsproviderName = false;
    }
  else  if (type == 'facility'){
      this.patientintakedata.lastProcedure = values
      if(values == 'Yes')
       this.IsfacName = true;
      else
      this.IsfacName = false;
    }
  else if (type == 'physician'){
      this.patientintakedata.isPrimaryCarePhysician = values
      if(values == 'Yes')
       this.IsphyName = true;
      else
      this.IsphyName = false;
    }
    else if (type == 'script'){
      this.patientintakedata.ptScript = values 
      if(values == 'Yes')
       this.Isscript = true;
      else
      this.Isscript = false;
    }
    
   
  }


  sendPatInfo(){
  
  //  this.questionnaire_two =
  //   'Injured: ' + this.patientRefdata_two.Is_Patinjured + ', ' +
  //  ' Worker Comp: ' +  this.patientRefdata_two.work_comp + ', ' +
  //  ' What was your injury: ' + this.patientRefdata_two.injury + ', ' + 
  //  ' Have you seen anyone else for this injury: ' + this.patientRefdata_two.Seen_pro + ', ' + 
  //  ' Provider Name: ' + this.patientRefdata_two.pro_name + ', ' +
  //  ' Do you have an MRI,X-ray or Blood work done: ' + this.patientRefdata_two.x_ray + ', ' +
  //  ' Facility Name: ' + this.patientRefdata_two.facility_name + ', ' +
  //  ' Do you have a primary care physician: ' + this.patientRefdata_two.is_phy + ', ' + 
  //  ' Name of last physician: ' + this.patientRefdata_two.phy_name + ', ' +
  //  ' When was your last physical: ' + this.patientRefdata_two.last_phy + ', ' + 
  //  ' When was your last set of full blood work: ' + this.patientRefdata_two.last_blood + ', ' +
  //  ' If scheduling with PT, do you have a PT Script: ' + this.patientRefdata_two.pt_script + ', ' +
  //  ' Referring Doctor: ' + this.patientRefdata_two.ref_doc + ', ' +
  //  ' Date of RX: ' + this.patientRefdata_two.rx_date + '.' ;
   


                  //  this.sendInjdata.patientAccount = this.patientPersonalInfo.PATIENT_ACCOUNT;
                  //   this.sendInjdata.practiceCode = this.patientPersonalInfo.PRACTICE_CODE;
                  //   this.sendInjdata.description = this.questionnaire_one;
                  //   this.sendInjdata.additionalDetail = this.questionnaire_two;
                    
                    this.patientintakedata.patientAccount = this.patientPersonalInfo.PATIENT_ACCOUNT;
                    this.patientintakedata.practiceCode = this.patientPersonalInfo.PRACTICE_CODE;



   this.spinner.show();             
   this._login.SaveInjurydetails(this.patientintakedata).subscribe((res: any) => {
     this.spinner.hide();
     if (res && res.statusCode == 200) {

       this._phrutilService.showSuccess("Record saved successfully");
        this.router.navigateByUrl("/intake");
          //this.router.navigateByUrl("/patient/intake/allergy");
     } else {
       this._phrutilService.showError("Some error occured.");
     }
   }, (error: any) => {
    
     this._phrutilService.showError("Some error occured.");
     this.spinner.hide();
   });

  }
  

}
